import { render, staticRenderFns } from "./Page13.vue?vue&type=template&id=e1c255b2&"
import script from "./Page13.vue?vue&type=script&lang=js&"
export * from "./Page13.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports